import { useState } from "react"

// UI
import { cn } from "@/lib/utils"

// Icons
import { IoStar, IoStarOutline } from "@/lib/icons"

// Translations
import { useTrans } from "@/i18n"

interface StarRatingProps {
	value: number
	onChange: (value: number) => void
	className?: string
}

export function StarRating({ value, onChange, className }: StarRatingProps) {
	const t = useTrans("dashboard")
	const [hoverValue, setHoverValue] = useState<number | null>(null)

	const activeValue = hoverValue ?? value

	return (
		<div
			className={cn("flex items-center justify-center gap-2", className)}
			role="radiogroup"
		>
			{[1, 2, 3, 4, 5].map((star) => {
				const isFilled = star <= activeValue
				const Icon = isFilled ? IoStar : IoStarOutline
				const label = t("dashboard:rating_modal.aria.star", {
					count: star,
				})

				return (
					<button
						key={star}
						type="button"
						role="radio"
						aria-checked={value === star}
						aria-label={label}
						onClick={() => onChange(star)}
						onMouseEnter={() => setHoverValue(star)}
						onMouseLeave={() => setHoverValue(null)}
						onFocus={() => setHoverValue(star)}
						onBlur={() => setHoverValue(null)}
						className={cn(
							"focus-visible:ring-primary-500 rounded-full p-1 transition-transform hover:scale-110 focus:outline-hidden focus-visible:ring-2",
							isFilled ? "text-yellow-400" : "text-gray-300",
						)}
					>
						<Icon className="size-10" aria-hidden="true" />
					</button>
				)
			})}
		</div>
	)
}
